import request, { requestAuth } from '@/utils/request'
import type { IOrganPerson, IOrganPersonInfo } from '@/store/models/organStructure.model'

export const getOrganList = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/orgChart',
})
export const addOrganPerson = (data: IOrganPerson): Promise<any[]> => request({
    method: 'POST',
    url: '/api/pangooITMT/orgChart',
    data
})
export const editOrganPerson = (data: IOrganPerson): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/orgChart/${data.id}`,
    data
})
export const delOrganPerson = (id: number): Promise<any[]> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/orgChart/${id}`,
})
export const getOrganPersonAvatar = (path: string): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/orgChart/avatar',
    params: {
        path
    }
})
// 获取通过用户 uidq 或用户名获取人员信息
export const getOrganPersonName = async (uidqName: string): Promise<{
    content: IOrganPersonInfo[]
    pageNo: number
    pageSize: number
    totalPages: number
    totalSize: number
}> => requestAuth({
    method: 'GET',
    url: '/api/pangooAuth/user',
    params: { nickName: uidqName },
})
